import { ChannelExtended } from "../pages/chat/components/ChatListTile";
import { ChatChannelMessage } from "./ChatChannelMessage";
import { FriendshipStatus } from "./FriendshipStatus";
import { UserBadgeType } from "./UserBadgeType";

export enum ChatChannelType {
    Messaging = 'messaging',
    Event = 'event',
    Group = 'group',
}

export interface ChatChannelInterface {
    id: string;
    name?: string;
    image?: string;
    slug?: string;
    badge?: UserBadgeType;
    lastMessage: ChatChannelMessage | null;
    isMuted: boolean;
    memberCount: number;
    unreadCount: number;
    friendshipStatus: FriendshipStatus;
    channel: ChannelExtended;
    type: ChatChannelType | null;
}

export abstract class ChatChannel implements ChatChannelInterface {
    id: string;
    name?: string;
    image?: string;
    slug?: string;
    badge?: UserBadgeType;
    lastMessage: ChatChannelMessage | null;
    isMuted: boolean;
    memberCount: number;
    unreadCount: number;
    friendshipStatus: FriendshipStatus;
    channel: ChannelExtended;
    type: ChatChannelType | null;

    constructor(data: ChatChannelInterface) {
        this.id = data.id;
        this.name = data.name;
        this.image = data.image;
        this.slug = data.slug;
        this.badge = data.badge;
        this.lastMessage = data.lastMessage;
        this.isMuted = data.isMuted;
        this.memberCount = data.memberCount;
        this.unreadCount = data.unreadCount;
        this.friendshipStatus = data.friendshipStatus;
        this.channel = data.channel;
        this.type = data.type;
    }
}